<template>
  <div :class="componentClass">

    <p>{{ widgetInfo.widgetDescription }}</p>

    <!--Warning Alert-->
    <div class="alert alert-warning text-left smaller-font-content py-2" role="alert">
      <div class="row no-gutters w-100">
        <div class="d-inline-block my-auto mr-2 align-middle"><i class="fas fa-exclamation-circle"></i></div>
        <div class="d-inline-block col">It is required that an agent's <strong>First Name</strong>, <strong>Middle Initial</strong> and <strong>Last Name</strong> match the agent's <strong>Agent of Record</strong> in Progressive's system. This is required for agents to bind Progressive policies within the QuinStreet Rating Platform.</div>
      </div>
    </div>

    <div class="row no-gutters mt-4 text-center">
      <div class="col-12 col-md-6 col-lg-8">
        <b-form-file v-model="userFile" class="mt-3" plain @change="onFileChange" :ref="'uploadUserList'"></b-form-file>
      </div>
    </div>
    <p class="mt-3 smaller-font-content text-left">{{ widgetInfo.widgetDescriptionFooter }}</p>
  </div>
</template>

<script>
import { csvParseToJson } from '../../services/csvHandlers';
import filters from '../../../config/admin/filters';

export default {
  props: ['widgetInfo'],
  data() {
    return {
      isLoading: false,
      userFile: null,
    };
  },
  components: {
  },
  computed: {
    componentClass() {
      return `${this.widgetInfo.widgetName}-block`;
    },
    userList: {
      get() {
        return this.$store.state.importUsers.userList;
      },
      set() {
        // this.$store.commit('updateUserList', value); // TODO: Set store value
      },
    },
  },
  methods: {
    csvToJson(source) {
      const parsedData = csvParseToJson(source);

      if (parsedData.errors && parsedData.errors.length > 0) {
        window.console.warn('An error occurred while parsing the data', parsedData.errors);

        this.$store.commit('updateAlerts', {
          messages: [
            '<b>Error: 0 Users Were Added.</b> Please make sure your new user file is formatted properly and try again (Example Below).',
          ],
          variant: 'danger',
        });

        parsedData.data = []; // Reset data to 0 rows
      }

      const formattedUsersList = [];

      if (Array.isArray(parsedData.data)) {
        // const capitalizeString = (string) => {
        //   const loweredRoleString = string.toLowerCase();

        //   return loweredRoleString.charAt(0).toUpperCase() + loweredRoleString.slice(1);
        // };

        // const formatRoleString = (roleString) => {
        //   const roleArray = roleString.trim().split(' ');
        //   const formattedArray = [];

        //   roleArray.forEach((string) => {
        //     formattedArray.push(capitalizeString(string));
        //   })

        //   return formattedArray.join('');
        // };
        // formatRoleString removes spaces and turns to lowercase.
        const formatRoleString = (roleString) => {
          if (typeof roleString === 'string') {
            const splitString = roleString.trim().toLowerCase().split(' ');
            return splitString.join('');
          }
          return '';
        };

        const getFormattedRole = (roleFromCSV) => {
          if (filters.userRoles[formatRoleString(roleFromCSV)]) {
            return filters.userRoles[formatRoleString(roleFromCSV)].roleValue;
          }
          return '';
        };

        parsedData.data.forEach((row) => {
          const formattedRow = {};
          formattedRow.discard = false; // Discard toggle
          formattedRow.firstName = row.firstName;
          formattedRow.lastName = row.lastName;
          formattedRow.middleInitial = row.middleInitial;
          formattedRow.phoneNumber = row.phoneNumber;
          formattedRow.email = row.email;
          // uses filters.userRoles dictionary to standardize user inputted csv values for role and looks up the case-sensitive version to pass to API.
          formattedRow.role = getFormattedRole(row.role);

          formattedUsersList.push(formattedRow);
        });
      }

      return { dataRows: formattedUsersList };
    },
    onFileChange(event) {
      const reader = new FileReader();

      reader.onload = ((e) => {
        const userListContents = this.csvToJson(e.target.result); // Populate data rows
        userListContents.isInitialUserList = true; // Flag list as initial list (not saved)
        window.console.info('File user list first loaded', userListContents);
        this.$store.commit('updateUserList', userListContents); // Save formatted data from file to store
        this.userFile.value = ''; // Reset to allow the @change trigger even if the same file is selected again
        console.log('dddd', this.$refs.uploadUserList);
        this.$refs.uploadUserList.reset();
      });

      reader.readAsText(event.target.files[0]);
    },
  },
};
</script>

<style scoped>
/**WIDGET STYLING**/
.card.no-padding,
.card.no-padding .card-body {
  padding: 0 !important;
}

/**WIDGET LOADING ANIMATION**/
.widget-loader .loader-content{
  position: absolute;
  top: 37%;
  left: 0;
  right: 0;
  max-width: 150px;
  min-width: 150px;
  padding: 0.5rem;
  margin: auto;
  color: #3674B2;
  background:rgba(255,255,255, 0.8);
  border-radius: 0.25rem;
}
</style>
<style>
i.fa-circle-o-notch:before{
  content: "\f1ce";
  font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
  color: #3674B2;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/UploadusersBlock.vue?fb737158